import { render } from "./create_variate.vue?vue&type=template&id=794d529d&scoped=true"
import script from "./create_variate.vue?vue&type=script&lang=js"
export * from "./create_variate.vue?vue&type=script&lang=js"

import "./create_variate.vue?vue&type=style&index=0&id=794d529d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794d529d"]])

export default __exports__